import { render } from "./Tabnav.vue?vue&type=template&id=74f6597e&scoped=true"
import script from "./Tabnav.vue?vue&type=script&lang=js"
export * from "./Tabnav.vue?vue&type=script&lang=js"

import "./Tabnav.vue?vue&type=style&index=0&id=74f6597e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f6597e"]])

export default __exports__